import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Service } from "../../models/Service";

export interface selectedServicesState {
  servicesId: number[];
  services: Service[];
}

const initialState: selectedServicesState = {
  servicesId: [],
  services: [],
};

export const selectedServicesSlice = createSlice({
  name: "selectedServices",
  initialState,

  reducers: {
    setServices: (state, action: PayloadAction<Service[]>) => {
      state.services = action.payload;
    },
    addService: (state, action: PayloadAction<Service>) => {
      state.services.find((s: Service) => s.id === action.payload.id)
        ? state.services.map((service: Service, index: number) => {
            if (service.id === action.payload.id) {
              state.services.splice(index, 1);
            }
          })
        : state.services.push(action.payload);
    },
    deleteService: (state, action: PayloadAction<Service>) => {},
    setServicesId: (state, action: PayloadAction<number[]>) => {
      state.servicesId = action.payload;
    },
    addServiceId: (state, action: PayloadAction<number>) => {
      state.servicesId.find((s: number) => s === action.payload)
        ? state.servicesId.map((serviceId: number, index: number) => {
            if (serviceId === action.payload) {
              state.servicesId.splice(index, 1);
            }
          })
        : state.servicesId.push(action.payload);
    },
    deleteServiceId: (state, action: PayloadAction<number>) => {},
  },
});

export const {
  setServices,
  addService,
  deleteService,
  setServicesId,
  addServiceId,
  deleteServiceId,
} = selectedServicesSlice.actions;

export default selectedServicesSlice.reducer;
